import useOnClickOutside from '@/hooks/useOnClickOutside'
import DownIcons from '@/icons/DownIcons'
import { sidebarMenus } from '../constants'
import { useMemo, useRef, useState } from 'react'
import Item from './Item'

const SidebarMobile = () => {
    const [showAllMenu, setShowAllMenu] = useState(false)

    const menuRef = useRef<HTMLDivElement>(null)

    const menus = useMemo(() => {
        return sidebarMenus?.slice(0, !showAllMenu ? 4 : sidebarMenus?.length)
    }, [sidebarMenus, showAllMenu])

    useOnClickOutside(menuRef, () => {
        setShowAllMenu(false)
    })

    return (
        <div
            ref={menuRef}
            className={`flex fixed bottom-0 w-full bg-white z-[9999] md:hidden `}
        >
            <div className="grid grid-cols-4 shadow-md flex-1">
                {menus?.map((item, index) => (
                    <Item key={index} item={item} />
                ))}
            </div>

            <div
                className="p-2 flex flex-col items-center cursor-pointer justify-center"
                onClick={() => setShowAllMenu(!showAllMenu)}
            >
                <div className="w-6 h-6">
                    <DownIcons
                        className={`${showAllMenu ? 'rotate-180' : ''} transition-all`}
                    />
                </div>
            </div>
        </div>
    )
}

export default SidebarMobile
